module.exports = __webpack_public_path__ + "static/media/Logodoradobet.8525745e.png";